/***
 * 创建人：D
 * 时间：2019-02-25
 * 描述：右侧菜单栏的循环递归（目前只有两级）有问题！！
 */
import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { SwMenuService } from 'src/app/librarys/serves/sw-menu.service';
import { Router } from '@angular/router';
import { SwRouteguardService } from 'src/app/librarys/serves/sw-routeguard.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { environment } from 'src/environments/environment';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { GetUserModelService } from 'src/app/librarys/serves/public/get-user-model.service';
import { SystemIdService } from 'src/app/librarys/serves/public/system-id.service';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
declare var $: any;
@Component({
  selector: 'sw-tree-menu',
  templateUrl: './sw-tree-menu.component.html',
  styleUrls: ['./sw-tree-menu.component.css']
})
export class SwTreeMenuComponent implements OnInit {

  /**
   * 地址栏路径
   */
  @Input() url:string

  AreasName: string; //模块名称
  Menus: any = []; //绑定数据
  OriginMenus: any = []; //下级数据
  activeId = ""; //选中的菜单id 
  menuList: any;

  activteMenuId = null;//当前点击的菜单Id
  activteMenuId2 = null;//当前点击的二级菜单Id
  prevAnimation = null; //上一个展开的菜单
  prevAnimation2 = null;//上一个展开的二级菜单
  isEnUs:boolean = false; //当前语言是否为英文English 是英文为true  不是英文（是中文）为false
  
  menusTreeSubscriptiona:any  //侧边菜单订阅对象

  /**
   * 打开新标签页的a标签的属性值
   * @ignore
   */
  routerLink:string = ""

  /**
   * 打开新标签页的a标签的属性值
   * @ignore
   */
  queryParams:any
  constructor(
    private Const: SwMenuService, //菜单服务
    private router: Router,    //路由跳转
    private box: SwMassageBoxService,
    private _http: SwHttpClientService,
    private user: GetUserModelService,
    private systemId: SystemIdService,
    private jwt:SwJwtService
  ) {
    let currLanguage = this.jwt.getToken('language')
    if(currLanguage == 'en-US'){
     this.isEnUs = true
    }else {
      this.isEnUs = false
    }
  }

  ngOnDestroy(): void {
    if(this.menusTreeSubscriptiona){
      this.menusTreeSubscriptiona.unsubscribe()  //取消订阅
    }
  }
  
  ngOnInit() {
  }

  urlAllPath:any[] = []
  ngOnChanges(changes: SimpleChanges): void {
    if(this.Menus.length && changes.url){
      this.changeHighlightMenu()
    }

  }

  /**
   * 地址栏路由改变或是左侧菜单替换之后，修改对应的高亮菜单
   */
  changeHighlightMenu(){
    this.urlAllPath = []
    //先根据当前路径获取对应的菜单
    this.getUrl(this.url,this.Menus)
    if(this.urlAllPath.length){
      //再根据当前菜单获取它的父级
      this.findParent(this.Menus,this.urlAllPath[0])
      //找到之后，再根据 this.urlAllPath 的个数，分辨是几级菜单
      if(this.urlAllPath.length == 1){
        if(this.activteMenuId != this.urlAllPath[0]['functionId']){
          //如果数组只有一个，就相当于只有本身，没有其他父级，就只有 activteMenuId 
          this.activteMenuId = this.urlAllPath[0]['functionId']
          this.activteMenuId2 = null
          this.activeId = this.urlAllPath[0]['functionId']
          $(".prevAnimation").slideUp(500);  //如果本身是一级菜单，将其他展开的一级菜单收起
        }
      } else if(this.urlAllPath.length == 2){  
        if(this.activteMenuId != this.urlAllPath[1]['functionId']){  
          $(".prevAnimation").slideUp(500);  //如果本身是一级菜单，将其他展开的一级菜单收起
          this.activteMenuId = this.urlAllPath[1]['functionId']
          this.activteMenuId2 = this.urlAllPath[0]['functionId']
          this.activeId = this.urlAllPath[0]['functionId']
          setTimeout(() => {
            $(".prevAnimation").slideDown(500);  //如果本身是二级菜单，将一级菜单展开
            $(".prevAnimation2").slideUp(500);  //如果本身是二级菜单，其他二级菜单收起
          }, 10);
        } else{    //如果之前展开的就是这个菜单重新展开收起，直接切换高亮的就行
          this.activteMenuId2 = this.urlAllPath[0]['functionId']
          this.activeId = this.urlAllPath[0]['functionId']
        }
      } else if(this.urlAllPath.length == 3){
        $(".prevAnimation").slideDown(500);  
        $(".prevAnimation2").slideDown(500); 
        this.activteMenuId = this.urlAllPath[2]['functionId']
        this.activteMenuId2 = this.urlAllPath[1]['functionId']
        this.activeId = this.urlAllPath[0]['functionId']
      }
    } else {
      //当前路由对应的菜单在左侧菜单中没有找到，高亮的还是之前的菜单
      // this.activteMenuId = null
      // this.activteMenuId2 = null
      // this.activeId = null
      // $(".prevAnimation").slideUp(500);  
      // $(".prevAnimation2").slideUp(500); 
    }

  }

  /**
   * 根据 url 在 tree 中找到对应的菜单
   * @param url 
   * @param tree 
   */
  getUrl(url,tree){
    for (let i = 0; i < tree.length; i++) {
      if(tree[i].uri == url){  //找到了该节点的父级，如果父级还有父级，就继续找
        this.urlAllPath.push(tree[i])
        return
      }
      if(tree[i]['children'] && tree[i]['children']['length']){  //还有子级就递归处理
        this.getUrl(url,tree[i]['children'])
      }
    }
  }
  

  /**
   * 根据节点找到其所有的父节点，放在 this.urlAllPath 数组中
   * @param menus 要处理的数组
   * @ignore
   */
  findParent(tree,node){
    if(node.parentId){
      //找到该节点的所有父级
      for (let i = 0; i < tree.length; i++) {
        if(tree[i].functionId == node.parentId){  //找到了该节点的父级，如果父级还有父级，就继续找
          this.urlAllPath.push(tree[i])  //找到了父级
          if(tree[i]['parentId']){
            this.findParent(this.Menus,tree[i])
          }
        }
        if(tree[i]['children'] && tree[i]['children']['length']){  //还有子级就递归处理
          this.findParent(tree[i]['children'],node)
        }
      }
    }
  }

  //加载下级菜单
  getMenuList(module, element, lv) {
    if (module) {
      if (lv == 1) {
        if (this.activteMenuId == module.functionId) {
          //当前菜单，则是收起操作，执行slideUp动画，并重置activteMenuId;
          this.activteMenuId = null;
          //子集已经有数据了，则视为已请求过，不再重复请求了
          if (element.srcElement) {
            if (element.srcElement.tagName != "A") {
              $(element.srcElement).parents('a').next('ul').slideUp(500);
            } else {
              $(element.srcElement).next('ul').slideUp(500);
            }
          }
          return;
        } else {
          //不是当前菜单，先判断有没有获取过子集，有的话直接执行slideDown动画，没有则去请求
          if (this.activteMenuId != null) {
            //先关闭之前打开的菜单下拉框
            $(".prevAnimation").slideUp(500);
          }
         
          if (module.children && module.children.length > 0) {
            if (element.srcElement) {
              if (element.srcElement.tagName != "A") {
                $(element.srcElement).parents('a').next('ul').slideDown(500);
              } else {
                $(element.srcElement).next('ul').slideDown(500);
              }
            }
            //下拉，然后记录当前activteMenuId
            this.activteMenuId = module.functionId;
            return;
          }
        }
      } else if (lv == 2) {
        if (this.activteMenuId2 == module.functionId) {
          //当前菜单，则是收起操作，执行slideUp动画，并重置activteMenuId;
          this.activteMenuId2 = null;
          //子集已经有数据了，则视为已请求过，不再重复请求了
          if (element.srcElement) {
            if (element.srcElement.tagName != "A") {
              $(element.srcElement).parents('a').next('ul').slideUp(500);
            } else {
              $(element.srcElement).next('ul').slideUp(500);
            }
          }
          return;
        } else {
          //不是当前菜单，先判断有没有获取过子集，有的话直接执行slideDown动画，没有则去请求
          if (this.activteMenuId2 != null) {
            //先关闭之前打开的菜单下拉框
            $(".prevAnimation2").slideUp(500);
          }

          if (module.children && module.children.length > 0) {
            if (element.srcElement) {
              if (element.srcElement.tagName != "A") {
                $(element.srcElement).parents('a').next('ul').slideDown(500);
              } else {
                $(element.srcElement).next('ul').slideDown(500);
              }
            }
            //下拉，然后记录当前activteMenuId
            this.activteMenuId2 = module.functionId;
            return;
          }
        }
      }

      //获取当前用户信息
      let user = this.user.getUser();
      //请求加载数据
      this._http.Post(environment.seekerWebAPI + "function/queryFunctionsByUserId?parentId=" + module.functionId + "&lazy=true&depth=1" +
        "&systemId=" + this.systemId.getSystemId() + "&type=1" + "&userId=" + user["userId"]
        , {}).subscribe(
          data => {
            if (data["code"] === 200) {
              //去掉隐藏菜单
              let childenList=[];
              //筛选出不为隐藏的菜单
              if(data["data"]){
                childenList=data["data"].filter(x=>!x.isHidden && x.type == 1);
              }
              //赋值
              module.children = childenList;

              setTimeout(() => {
                if (element.srcElement) {
                  if (element.srcElement.tagName != "A") {
                    $(element.srcElement).parents('a').next('ul').slideDown(500);
                   
                  } else {
                    $(element.srcElement).next('ul').slideDown(500);
                  }
                  if (lv == 1) {
                    this.activteMenuId = module.functionId;
                  }else if(lv == 2){
                    this.activteMenuId2 = module.functionId;
                  }               
                }
              }, 0)

            }
          }
        )
    }
  }

  ngAfterViewInit() {
    //加载菜单下拉框事件
    // $('#abcde').tree({})
    //订阅菜单发布事件
    this.menusTreeSubscriptiona = this.Const.menusTreeUpdated.subscribe((val) => {
      //获取菜单数据
      let Areas = this.Const.getMenusVal();
      //如果是悬浮菜单,则取下级第一个模块
      if (Areas.css == "1" && Areas.children.length > 0) {
        //获取当前模块名称
        this.AreasName = this.isEnUs && Areas.children[0].functionNameEn ? Areas.children[0].functionNameEn : Areas.children[0].functionNameEn;
        //获取下级数据
        this.OriginMenus = Areas.children[0]["children"];
        //递归菜单 去掉隐藏的菜单
        this.Menus = this.filterMenus(this.OriginMenus);
        if (this.Menus == undefined) { this.Menus = {} }
      } else {
        //获取当前模块名称
        this.AreasName = this.isEnUs && Areas.functionNameEn ? Areas.functionNameEn : Areas.functionName;
        //获取下级数据
        this.OriginMenus = Areas["children"];
        //递归菜单 去掉隐藏的菜单
        this.Menus = this.filterMenus(this.OriginMenus);
        if (this.Menus == undefined) { this.Menus = {} }
      }
      //默认打开第一个子级页面,前提是 不是从首页过来的--!val.isFromProtal，且不是打开新标签页--!val.isTargetBlank ; 或者是跳转到指定页面
      if (this.OriginMenus && this.OriginMenus.length > 0 && val != 1 && !val.isFromProtal && !val.isTargetBlank || val.RedirectUrl) {
        if(val.RedirectUrl){
          setTimeout(() => {    //这里之所以用定时器是为了：在 home 中调用了 sw-menu.service 中的 location 方法中，又跳转到了默认首页，这里就在最后再跳
            this.RouterLinekEx({uri:val.RedirectUrl , functionName:'视觉资产库' , functionId:''},val.queryParams)
          }, 0);
        } else {
          //如果第一个菜单下面还有子级菜单,则继续往下找,目前最多只往下找一级
          if (this.OriginMenus[0].children && this.OriginMenus[0].children.length > 0) {
  
            //找到非隐藏菜单打开,都是隐藏菜单则不执行打开
            let menu = this.OriginMenus[0].children.filter(x => x.isHidden == false);
            if (menu.length > 0 && environment.openDefaultMenu == true) {
              this.RouterLinekEx(menu[0])
            }
          } else {
            //找到非隐藏菜单打开,都是隐藏菜单则不执行打开
            let menu = this.OriginMenus.filter(x => x.isHidden == false);
            if (menu.length > 0 && environment.openDefaultMenu == true) {
              this.RouterLinekEx(menu[0])
            }
          }

        }
      }
      if (this.Menus.length == 0 || environment.fullScreen == '*') {
        // 当左侧菜单没有数据或者是配置了所有页面全屏的时候，就需要全屏
        this.Const.isFullScreenUpdated.next({isFull:true,isInit:val})
      } else {
        // 不需要全屏
        this.Const.isFullScreenUpdated.next({isFull:false,isInit:val})
      }
      if(this.Menus.length){
        //模块切换之后，修改高亮菜单
        this.changeHighlightMenu()
      }
    })
  }

  //递归去掉隐藏的菜单
  filterMenus(inMenus) {
    //如果传入null或者undefined直接返回[];
    if (!inMenus) {
      return [];
    }
    //获取不隐藏的菜单
    inMenus = inMenus.filter(element => !element.isHidden && element.type == 1);
    if (inMenus.length) {
      for (let i = 0; i < inMenus.length; i++) {
        if (inMenus[i].children != null) {
          if (inMenus[i].children.length) {
            let nextInMenus = inMenus[i].children;
            inMenus[i].children = this.filterMenus(nextInMenus);
          }
        } else {
          inMenus[i].children = [];
        }

      }
    }
    return inMenus;
  }

  //链接跳转 方法
  RouterLinek(Menus,lv) {
    if(lv==1){
      $(".prevAnimation").slideUp(500);
      this.activteMenuId = Menus.functionId;
      this.activteMenuId2 = null
    }else if(lv==2){
      $(".prevAnimation2").slideUp(500);
      this.activteMenuId2 = Menus.functionId;
    }
    this.activeId = Menus.functionId;
    this.jwt.setToKen("activeFunction",JSON.stringify(Menus));
    
    if (Menus.target == "SYS0402") {
      //如果是使用新标签页打开,就直接打开新标签页
      if (Menus.uri) {
        if(Menus.uri.indexOf('://') > -1 || Menus.uri[0] != '/'){
          //要跳转到外部链接
          window.open(Menus.uri)
        } else {
          //跳转到项目内部的链接（菜单）
          this.routerLink = Menus.uri
          this.queryParams = { Title: Menus.functionName ,target:'_blank'}
          setTimeout(() => {
            let elelink = document.getElementById('newUseApplyLink')
            elelink.click()
          }, 20);
        }
      } else {
        this.box.danger('无跳转路径！')
      }
    } else {
      //默认方式打开
      if (!Menus.uri) {
        return;
      }
      let uri = Menus.uri.toLocaleLowerCase()
      if (uri.indexOf('http://') != -1 || uri.indexOf('https://') != -1) {
        //如果是打开外部链接,项目中没有对应的页面,就使用固定的tab页打开
        //跳到专门的tab页,在tab页中使用iframe标签打开外部链接
        this.router.navigate(['/bdp/ExternalLinks'], {
          queryParams: { Title: this.isEnUs && Menus.functionNameEn ? Menus.functionNameEn : Menus.functionName, uri: Menus.uri, id: 'externallinks' + Math.random().toString().split(".")[1] },
        });
      } else {
        //默认方式打开,根据路由跳转链接
        this.router.navigate([Menus.uri], {
          queryParams: { Title: this.isEnUs && Menus.functionNameEn ? Menus.functionNameEn : Menus.functionName },
        });
      }
    }
  }


  //链接跳转扩展方法
  //queryParams--> 但站点登录时，在工作门户打开其他模块的磁贴，需要携带的参数
  RouterLinekEx(Menus,queryParams?) {
    if (Menus.target == "SYS0402") {
      //如果是使用新标签页打开,就不打开
      return;
    } else {
      this.activeId = Menus.functionId;
      this.jwt.setToKen("activeFunction",JSON.stringify(Menus));
      if (!Menus.uri) {
        return;
      }
      //默认方式tab页打开
      let uri = Menus.uri.toLocaleLowerCase()
      if (uri.indexOf('http://') != -1 || uri.indexOf('https://') != -1) {
        //如果是打开外部链接,项目中没有对应的页面,就使用固定的tab页打开
        //跳到专门的tab页,在tab页中使用iframe标签打开外部链接
        this.router.navigate(['/bdp/ExternalLinks'], {
          queryParams: { Title: this.isEnUs && Menus.functionNameEn ? Menus.functionNameEn : Menus.functionName, uri: Menus.uri, id: 'externallinks' + Math.random().toString().split(".")[1] },
        });
      } else {
        //默认方式打开,根据路由跳转链接
        if(queryParams){
          this.router.navigate([Menus.uri], {
            queryParams:  JSON.parse(queryParams),
          });

        } else {
          this.router.navigate([Menus.uri], {
            queryParams: { Title: this.isEnUs && Menus.functionNameEn ? Menus.functionNameEn : Menus.functionName },
          });

        }
      }
    }
  }
};